import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VideoOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsxs("g", {
                        children: [
                            _jsx("path", {
                                d: "M3.036 4.158L4.878 6H4a1 1 0 00-.993.883L3 7v10a1 1 0 001 1h11a1 1 0 001-1l-.007.114 1.522 1.522a2.998 2.998 0 01-2.339 1.359L15 20H4a3 3 0 01-3-3V7c0-1.32.852-2.44 2.036-2.842zm18.161 13.614C21.076 17.627 21 17.389 21 17V7.386l-3.439 2.33A1 1 0 0116 8.89V7a1 1 0 00-1-1H9.12l-2-2H15a3 3 0 012.995 2.826l.005.177 3.439-1.83A1 1 0 0123 6v11c0 .5 0 1-1 1h-.083c-.25-.002-.492-.017-.665-.171l-.019-.021z"
                            }),
                            _jsx("path", {
                                d: "M.293 1.707l22 22a1 1 0 001.414-1.414l-22-22A1 1 0 10.293 1.707z"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
VideoOffIcon.isCarinaIcon = true;
export default VideoOffIcon;
